import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { MAILTO } from '../data/content';
export function Hero() {
  return <section id="top" className="border-b border-hairline bg-white" data-id="element-74" data-mp="ej4nvyioidfz">
      <div className="mx-auto max-w-content px-5 pb-20 pt-28 sm:px-8 sm:pb-28 sm:pt-36" data-id="element-75" data-mp="9ka71249uyyi">
        <div className="max-w-3xl" data-id="element-76" data-mp="4lywsqa2emfr">
          <h1 className="text-4xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-77" data-mp="4n1k6o86i6qx">
            Marketing that grows your business
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-muted sm:text-xl" data-id="element-78" data-mp="x9un9d91ji43">
            We help companies grow through paid media, social and data-driven
            strategy — with hands-on campaign management and clear monthly
            reporting.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-79" data-mp="3d1a83izra9cr">
            <a href={MAILTO} className="inline-flex items-center justify-center whitespace-nowrap rounded-lg bg-accent px-6 py-3 text-[15px] font-medium text-white transition-colors duration-150 ease-out hover:bg-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-80" data-mp="3cz5v8bjvq00c">
              Get in touch
            </a>
            <a href="#services" className="group inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-2 py-3 text-[15px] font-medium text-ink-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 sm:px-3" data-id="element-81" data-mp="3e9frdcsh26lo">
              View services
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-82" data-mp="2viy43nqes37p" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}